import { render, staticRenderFns } from "./GSchoolClassChangeWorkSpaceDraggable.vue?vue&type=template&id=01f4f44d&scoped=true&"
import script from "./GSchoolClassChangeWorkSpaceDraggable.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChangeWorkSpaceDraggable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4f44d",
  null
  
)

export default component.exports